<div class="video-modal">
    <div class="video-modal__header">
        <h3>{{ title }}</h3>
        <button type="button" class="video-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <div class="video-modal__frame">
        <iframe [src]="embedUrl" [title]="title" frameborder="0" allowfullscreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
        </iframe>
    </div>
</div>
